import { SET_PO_DISPLAY_ID, SET_PO_VENDOR_ID, SET_PO_PRODUCTS, SET_PO_DATE, SET_PO_STATUS, SET_PO_PAYMENTS, SET_PO_RECEIVED, SET_NEW_PO_INFO, CLEAR_NEW_PO } from 'redux/actionTypes';
import { Pending } from 'variables/status';

const initialState = {
    displayId: "",
    vendorId: 0,
    poProducts: [],
    startDate: null,
    endDate: null,
    status: Pending,
    total: 0,
    payments: [],
    received: false
};

export default function newPurchaseOrder(state = initialState, action) {
    switch(action.type) {
        case SET_PO_DISPLAY_ID:
            return {
                ...state,
                displayId: action.payload
            };
        case SET_PO_VENDOR_ID:
            return {
                ...state,
                vendorId: action.payload
            };
        case SET_PO_PRODUCTS:
            return {
                ...state,
                poProducts: action.payload
            };
        case SET_PO_DATE:
            return {
                ...state,
                startDate: action.payload.startDate,
                endDate: action.payload.endDate
            };
        case SET_PO_STATUS:
            return {
                ...state,
                status: action.payload
            };
        case SET_PO_PAYMENTS:
            return {
                ...state,
                payments: action.payload
            };
        case SET_PO_RECEIVED:
            return {
                ...state,
                received: action.payload
            };
        case SET_NEW_PO_INFO:
            return {
                displayId: action.payload.displayId,
                vendorId: action.payload.vendorId,
                poProducts: action.payload.poProducts,
                startDate: action.payload.startDate,
                endDate: action.payload.endDate,
                status: action.payload.status,
                total: action.payload.total,
                payments: action.payload.payments,
                received: action.payload.received
            };
        case CLEAR_NEW_PO:
            return {
                displayId: "",
                vendorId: 0,
                poProducts: [],
                startDate: null,
                endDate: null,
                status: Pending,
                total: 0,
                payments: [],
                received: false
            };
        default:
            return state;
    }
};